import BaseStyle from '../assets/css/Dashboard.module.css';
import TimelapsesStyle from '../assets/css/Timelapses.module.css';

import {useTheme} from "../provider/themeProvider";
import React, {useMemo} from "react";
import PopupDownNewSequence from "../components/PopupDown/PopupDownNewSequence";
import {usePopup} from "../services/PopupContext";
import {useAppContext} from "../provider/appProvider";
import dayjs from "dayjs";
import {useNavigate} from 'react-router-dom';
import {useDesktop} from "../provider/DesktopContext";

const Sequences = () => {
  const { darkMode } = useTheme();
  const { showPopup } = usePopup();
  const { timelapses, records } = useAppContext();
  const isDesktop = useDesktop();
  const navigate = useNavigate();

  const items = useMemo(() => {
    const tl = (timelapses ?? []).map(t => ({ ...t, _type: 'timelapse' }));
    const rc = (records ?? []).map(r => ({ ...r, _type: 'record' }));
    return [...tl, ...rc].sort((a, b) => {
      const dateA = new Date(a.createdAt ?? a.created_at);
      const dateB = new Date(b.createdAt ?? b.created_at);
      return dateB - dateA;
    });
  }, [timelapses, records]);

  const handleOpen = (item) => {
    if (item._type === 'timelapse') {
      navigate(`/timelapses/${item.id}`, { replace: true });
    } else {
      navigate(`/records/${item.id}`, { replace: true });
    }
  };

  return (
    <>
      {isDesktop &&
        <div className={BaseStyle.header}>
          <div className={BaseStyle.left}>
            <div className={BaseStyle.iconContainer}>
              <img src={`https://cdn.codnum.fr/watch4safe/assets/images/folder_${darkMode ? 'black' : 'white'}.svg`}
                   alt=""
                   height="20" width="20"/>
            </div>
            <div className={BaseStyle.description}>
              <span className={BaseStyle.title}>Séquences</span>
              <span className={BaseStyle.subTitle}>Toutes vos restitutions vidéo</span>
            </div>
          </div>
          <div className={BaseStyle.right}>
            <div
              className={BaseStyle.btnAction}
              onClick={() => showPopup(PopupDownNewSequence)}
            >
              <img src={`https://cdn.codnum.fr/watch4safe/assets/images/plus_${darkMode ? 'black' : 'white'}.svg`}
                   alt={''}
                   height={14} width={14}></img>
            </div>
          </div>
        </div>
      }
      <div className={TimelapsesStyle.contentContainer}>
        {items.map((item, index) => (
          <div key={index} className={TimelapsesStyle.timelapse} onClick={() => handleOpen(item)}>
            <div className={TimelapsesStyle.left}>
              <span className={TimelapsesStyle.title}>
                {item.title ?? (item._type === 'record' ? 'Restitution' : 'Séquence')}
              </span>
              <div className={TimelapsesStyle.leftCenter}>
                {item._type === 'timelapse' ? (
                  <span className={TimelapsesStyle.time}>
                    Du <b>{dayjs(item.start_at).format('DD MMMM YYYY [à] HH[h]mm')}</b> au <b>{dayjs(item.end_at).format('DD MMMM YYYY [à] HH[h]mm')}</b>
                  </span>
                ) : (
                  <span className={TimelapsesStyle.time}>
                    {item.target_time
                      ? <>Autour du <b>{dayjs(item.target_time).format('DD MMMM YYYY [à] HH[h]mm')}</b></>
                      : <b>{dayjs(item.created_at).format('DD MMMM YYYY [à] HH[h]mm')}</b>
                    }
                  </span>
                )}
                <span className={TimelapsesStyle.camera}>{item.camera?.name}</span>
              </div>
            </div>
            <div className={TimelapsesStyle.right}>
              <span className={TimelapsesStyle.created}>
                Créé le {dayjs(item.createdAt ?? item.created_at).format('DD MMMM YYYY [à] HH[h]mm')}
              </span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Sequences;
